import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import BoxedContainer from '../layouts/BoxedContainer';
import DesktopPartnersCards from './DesktopPartnersCards';
import MobilePartnersCards from './MobilePartnersCards';

export default function Partners({ data, partners }) {
  const { title, text } = data;
  
  return (
    <section
      className="relative z-10 lg:pt-[182px] pt-[90px] lg:pb-[194px] pb-[90px]
      clip-right-top bg-white lg:-mt-[80px] -mt-[20px] overflow-hidden our-partners-container"
    >
      <BoxedContainer className="boxed">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          viewport={{ once: true }}
          className="flex 3xl:pl-[200px] xl:pl-[100px] lg:pl-[50px] items-center"
        >
          <div className="flex flex-col xl:gap-y-[31px] gap-y-[18px] w-full">
            {isEmpty(title) || (
              <h3
                className={`
                ${title.includes("2023") 
                ? 'lg:text-2xl text-[35px] leading-normal' 
                : 'xl:text-[48px] lg:text-[30px] text-[36px] leading-[30px]'} 
                text-black font-roboto-condensed-bold uppercase`}
              >
                {title}
              </h3>
            )}
            {isEmpty(text) || (
              <p
                className="2xl:text-base text-[15px] leading-6 text-primary lg:w-[85%]
              font-roboto-regular"
              >
                {text}
              </p>
            )}
          </div>
        </motion.div>
      </BoxedContainer>

      <DesktopPartnersCards data={partners} />
      <MobilePartnersCards data={partners} />
      
    </section>
  );
}
